import { render, staticRenderFns } from "./Digitain.vue?vue&type=template&id=6a241bb4"
import script from "./Digitain.vue?vue&type=script&lang=js"
export * from "./Digitain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports